export default{
    "conditioninfo": [
        {
            "defaultshow": true,
            "items": [
                {
                    "colSpan": 2,
                    "conditionType": "INPUT",
                    "domkey": [
                        "requestname"
                    ],
                    "fieldcol": 18,
                    "isQuickSearch": false,
                    "label": "标题",
                    "labelcol": 6,
                    "viewAttr": 2
                },
                {
                    "colSpan": 2,
                    "conditionType": "INPUT",
                    "domkey": [
                        "wfcode"
                    ],
                    "fieldcol": 18,
                    "isQuickSearch": false,
                    "label": "流程编号",
                    "labelcol": 6,
                    "viewAttr": 2
                },
                {
                    "browserConditionParam": {
                        "completeParams": {
                            
                        },
                        "conditionDataParams": {
                            
                        },
                        "dataParams": {
                            
                        },
                        "destDataParams": {
                            
                        },
                        "hasAddBtn": false,
                        "hasAdvanceSerach": true,
                        "idSeparator": ",",
                        "isAutoComplete": 1,
                        "isDetail": 0,
                        "isMultCheckbox": false,
                        "isSingle": true,
                        "pageSize": 10,
                        "quickSearchName": "",
                        "title": "工作流",
                        "type": "-99991",
                        "viewAttr": 2
                    },
                    "colSpan": 2,
                    "conditionType": "BROWSER",
                    "domkey": [
                        "workflowid"
                    ],
                    "fieldcol": 18,
                    "isQuickSearch": false,
                    "label": "工作流",
                    "labelcol": 6,
                    "viewAttr": 2
                },
                {
                    "colSpan": 2,
                    "conditionType": "DATE",
                    "domkey": [
                        "createdateselect",
                        "createdatefrom",
                        "createdateto"
                    ],
                    "fieldcol": 18,
                    "isQuickSearch": false,
                    "label": "创建日期",
                    "labelcol": 6,
                    "options": [
                        {
                            "key": "0",
                            "selected": true,
                            "showname": "全部"
                        },
                        {
                            "key": "1",
                            "selected": false,
                            "showname": "今天"
                        },
                        {
                            "key": "2",
                            "selected": false,
                            "showname": "本周"
                        },
                        {
                            "key": "3",
                            "selected": false,
                            "showname": "本月"
                        },
                        {
                            "key": "4",
                            "selected": false,
                            "showname": "本季"
                        },
                        {
                            "key": "5",
                            "selected": false,
                            "showname": "本年"
                        },
                        {
                            "key": "6",
                            "selected": false,
                            "showname": "指定日期范围"
                        }
                    ],
                    "viewAttr": 2
                },
                {
                    "colSpan": 2,
                    "conditionType": "SELECT_LINKAGE",
                    "domkey": [
                        "creatertype",
                        "createrid",
                        "createrid2"
                    ],
                    "fieldcol": 18,
                    "isQuickSearch": false,
                    "label": "创建人",
                    "labelcol": 6,
                    "options": [
                        {
                            "key": "0",
                            "selected": true,
                            "showname": "员工"
                        },
                        {
                            "key": "1",
                            "selected": false,
                            "showname": "客户"
                        }
                    ],
                    "selectLinkageDatas": {
                        "0": {
                            "browserConditionParam": {
                                "completeParams": {
                                    
                                },
                                "conditionDataParams": {
                                    
                                },
                                "dataParams": {
                                    
                                },
                                "destDataParams": {
                                    
                                },
                                "hasAddBtn": false,
                                "hasAdvanceSerach": true,
                                "idSeparator": ",",
                                "isAutoComplete": 1,
                                "isDetail": 0,
                                "isMultCheckbox": false,
                                "isSingle": true,
                                "linkUrl": "/hrm/resource/HrmResource.jsp?id=",
                                "pageSize": 10,
                                "quickSearchName": "",
                                "title": "人力资源",
                                "type": "hrmgroup",
                                "viewAttr": 2
                            },
                            "colSpan": 2,
                            "conditionType": "BROWSER",
                            "domkey": [
                                "createrid"
                            ],
                            "fieldcol": 18,
                            "isQuickSearch": false,
                            "label": "null",
                            "labelcol": 6,
                            "viewAttr": 2
                        },
                        "1": {
                            "browserConditionParam": {
                                "completeParams": {
                                    
                                },
                                "conditionDataParams": {
                                    
                                },
                                "dataParams": {
                                    
                                },
                                "destDataParams": {
                                    
                                },
                                "hasAddBtn": false,
                                "hasAdvanceSerach": true,
                                "idSeparator": ",",
                                "isAutoComplete": 1,
                                "isDetail": 0,
                                "isMultCheckbox": false,
                                "isSingle": true,
                                "linkUrl": "/CRM/data/ViewCustomer.jsp?isrequest=1&CustomerID=",
                                "pageSize": 10,
                                "quickSearchName": "",
                                "title": "客户",
                                "type": "7",
                                "viewAttr": 2
                            },
                            "colSpan": 2,
                            "conditionType": "BROWSER",
                            "domkey": [
                                "createrid2"
                            ],
                            "fieldcol": 18,
                            "isQuickSearch": false,
                            "label": "null",
                            "labelcol": 6,
                            "viewAttr": 2
                        }
                    },
                    "viewAttr": 2
                },
                {
                    "colSpan": 2,
                    "conditionType": "INPUT",
                    "domkey": [
                        "workcode"
                    ],
                    "fieldcol": 18,
                    "isQuickSearch": false,
                    "label": "创建人编号",
                    "labelcol": 6,
                    "viewAttr": 2
                }
            ],
            "title": "基本条件"
        },
        {
            "defaultshow": true,
            "items": [
                {
                    "browserConditionParam": {
                        "completeParams": {
                            
                        },
                        "conditionDataParams": {
                            
                        },
                        "dataParams": {
                            
                        },
                        "destDataParams": {
                            
                        },
                        "hasAddBtn": false,
                        "hasAdvanceSerach": true,
                        "idSeparator": ",",
                        "isAutoComplete": 1,
                        "isDetail": 0,
                        "isMultCheckbox": false,
                        "isSingle": true,
                        "linkUrl": "/hrm/company/HrmDepartmentDsp.jsp?id=",
                        "pageSize": 10,
                        "quickSearchName": "",
                        "tabs": [
                            {
                                "isSearch": false,
                                "key": "2",
                                "name": "组织结构",
                                "selected": false
                            },
                            {
                                "dataParams": {
                                    "list": "1"
                                },
                                "isSearch": true,
                                "key": "1",
                                "name": "按列表",
                                "selected": false
                            }
                        ],
                        "title": "部门",
                        "type": "4",
                        "viewAttr": 2
                    },
                    "colSpan": 2,
                    "conditionType": "BROWSER",
                    "domkey": [
                        "ownerdepartmentid"
                    ],
                    "fieldcol": 18,
                    "isQuickSearch": false,
                    "label": "创建人部门",
                    "labelcol": 6,
                    "viewAttr": 2
                },
                {
                    "browserConditionParam": {
                        "completeParams": {
                            
                        },
                        "conditionDataParams": {
                            
                        },
                        "dataParams": {
                            
                        },
                        "destDataParams": {
                            
                        },
                        "hasAddBtn": false,
                        "hasAdvanceSerach": true,
                        "idSeparator": ",",
                        "isAutoComplete": 1,
                        "isDetail": 0,
                        "isMultCheckbox": false,
                        "isSingle": true,
                        "linkUrl": "/hrm/company/HrmSubCompanyDsp.jsp?id=",
                        "pageSize": 10,
                        "quickSearchName": "",
                        "tabs": [
                            {
                                "isSearch": false,
                                "key": "2",
                                "name": "组织结构",
                                "selected": false
                            },
                            {
                                "dataParams": {
                                    "list": "1"
                                },
                                "isSearch": true,
                                "key": "1",
                                "name": "按列表",
                                "selected": false
                            }
                        ],
                        "title": "分部",
                        "type": "164",
                        "viewAttr": 2
                    },
                    "colSpan": 2,
                    "conditionType": "BROWSER",
                    "domkey": [
                        "creatersubcompanyid"
                    ],
                    "fieldcol": 18,
                    "isQuickSearch": false,
                    "label": "创建人分部",
                    "labelcol": 6,
                    "viewAttr": 2
                },
                {
                    "browserConditionParam": {
                        "completeParams": {
                            
                        },
                        "conditionDataParams": {
                            
                        },
                        "dataParams": {
                            
                        },
                        "destDataParams": {
                            
                        },
                        "hasAddBtn": false,
                        "hasAdvanceSerach": true,
                        "idSeparator": ",",
                        "isAutoComplete": 1,
                        "isDetail": 0,
                        "isMultCheckbox": false,
                        "isSingle": true,
                        "pageSize": 10,
                        "quickSearchName": "",
                        "title": "路径类型",
                        "type": "wftype",
                        "viewAttr": 2
                    },
                    "colSpan": 2,
                    "conditionType": "BROWSER",
                    "domkey": [
                        "workflowtype"
                    ],
                    "fieldcol": 18,
                    "isQuickSearch": false,
                    "label": "类型",
                    "labelcol": 6,
                    "viewAttr": 2
                },
                {
                    "colSpan": 2,
                    "conditionType": "SELECT",
                    "domkey": [
                        "requestlevel"
                    ],
                    "fieldcol": 18,
                    "isQuickSearch": false,
                    "label": "紧急程度",
                    "labelcol": 6,
                    "options": [
                        {
                            "key": "",
                            "selected": true,
                            "showname": ""
                        },
                        {
                            "key": "0",
                            "selected": false,
                            "showname": "正常"
                        },
                        {
                            "key": "1",
                            "selected": false,
                            "showname": "重要"
                        },
                        {
                            "key": "2",
                            "selected": false,
                            "showname": "紧急"
                        }
                    ],
                    "viewAttr": 2
                },
                {
                    "colSpan": 2,
                    "conditionType": "DATE",
                    "domkey": [
                        "recievedateselect",
                        "recievedatefrom",
                        "recievedateto"
                    ],
                    "fieldcol": 18,
                    "isQuickSearch": false,
                    "label": "接收日期",
                    "labelcol": 6,
                    "options": [
                        {
                            "key": "0",
                            "selected": true,
                            "showname": "全部"
                        },
                        {
                            "key": "1",
                            "selected": false,
                            "showname": "今天"
                        },
                        {
                            "key": "2",
                            "selected": false,
                            "showname": "本周"
                        },
                        {
                            "key": "3",
                            "selected": false,
                            "showname": "本月"
                        },
                        {
                            "key": "4",
                            "selected": false,
                            "showname": "本季"
                        },
                        {
                            "key": "5",
                            "selected": false,
                            "showname": "本年"
                        },
                        {
                            "key": "6",
                            "selected": false,
                            "showname": "指定日期范围"
                        }
                    ],
                    "viewAttr": 2
                },
                {
                    "colSpan": 2,
                    "conditionType": "SELECT",
                    "domkey": [
                        "wfstatu"
                    ],
                    "fieldcol": 18,
                    "isQuickSearch": false,
                    "label": "流程状态",
                    "labelcol": 6,
                    "options": [
                        {
                            "key": "1",
                            "selected": true,
                            "showname": "有效"
                        },
                        {
                            "key": "0",
                            "selected": false,
                            "showname": "无效"
                        },
                        {
                            "key": "2",
                            "selected": false,
                            "showname": "全部"
                        }
                    ],
                    "viewAttr": 2
                },
                {
                    "colSpan": 2,
                    "conditionType": "SELECT",
                    "domkey": [
                        "nodetype"
                    ],
                    "fieldcol": 18,
                    "isQuickSearch": false,
                    "label": "节点类型",
                    "labelcol": 6,
                    "options": [
                        {
                            "key": "",
                            "selected": true,
                            "showname": ""
                        },
                        {
                            "key": "0",
                            "selected": false,
                            "showname": "创建"
                        },
                        {
                            "key": "1",
                            "selected": false,
                            "showname": "批准"
                        },
                        {
                            "key": "2",
                            "selected": false,
                            "showname": "提交"
                        },
                        {
                            "key": "3",
                            "selected": false,
                            "showname": "归档"
                        }
                    ],
                    "viewAttr": 2
                },
                {
                    "browserConditionParam": {
                        "completeParams": {
                            
                        },
                        "conditionDataParams": {
                            
                        },
                        "dataParams": {
                            
                        },
                        "destDataParams": {
                            
                        },
                        "hasAddBtn": false,
                        "hasAdvanceSerach": true,
                        "idSeparator": ",",
                        "isAutoComplete": 1,
                        "isDetail": 0,
                        "isMultCheckbox": false,
                        "isSingle": true,
                        "linkUrl": "/hrm/resource/HrmResource.jsp?id=",
                        "pageSize": 10,
                        "quickSearchName": "",
                        "title": "人力资源",
                        "type": "1",
                        "viewAttr": 2
                    },
                    "colSpan": 2,
                    "conditionType": "BROWSER",
                    "domkey": [
                        "unophrmid"
                    ],
                    "fieldcol": 18,
                    "isQuickSearch": false,
                    "label": "未操作者",
                    "labelcol": 6,
                    "viewAttr": 2
                },
                {
                    "browserConditionParam": {
                        "completeParams": {
                            
                        },
                        "conditionDataParams": {
                            
                        },
                        "dataParams": {
                            
                        },
                        "destDataParams": {
                            
                        },
                        "hasAddBtn": false,
                        "hasAdvanceSerach": true,
                        "idSeparator": ",",
                        "isAutoComplete": 1,
                        "isDetail": 0,
                        "isMultCheckbox": false,
                        "isSingle": true,
                        "linkUrl": "/docs/docs/DocDsp.jsp?isrequest=1&id=",
                        "pageSize": 10,
                        "quickSearchName": "",
                        "title": "文档",
                        "type": "9",
                        "viewAttr": 2
                    },
                    "colSpan": 2,
                    "conditionType": "BROWSER",
                    "domkey": [
                        "docids"
                    ],
                    "fieldcol": 18,
                    "isQuickSearch": false,
                    "label": "相关文档",
                    "labelcol": 6,
                    "viewAttr": 2
                },
                {
                    "browserConditionParam": {
                        "completeParams": {
                            
                        },
                        "conditionDataParams": {
                            
                        },
                        "dataParams": {
                            
                        },
                        "destDataParams": {
                            
                        },
                        "hasAddBtn": false,
                        "hasAdvanceSerach": true,
                        "idSeparator": ",",
                        "isAutoComplete": 1,
                        "isDetail": 0,
                        "isMultCheckbox": false,
                        "isSingle": true,
                        "linkUrl": "/hrm/resource/HrmResource.jsp?id=",
                        "pageSize": 10,
                        "quickSearchName": "",
                        "title": "人力资源",
                        "type": "1",
                        "viewAttr": 2
                    },
                    "colSpan": 2,
                    "conditionType": "BROWSER",
                    "domkey": [
                        "hrmcreaterid"
                    ],
                    "fieldcol": 18,
                    "isQuickSearch": false,
                    "label": "人力资源",
                    "labelcol": 6,
                    "viewAttr": 2
                },
                {
                    "browserConditionParam": {
                        "completeParams": {
                            
                        },
                        "conditionDataParams": {
                            
                        },
                        "dataParams": {
                            
                        },
                        "destDataParams": {
                            
                        },
                        "hasAddBtn": false,
                        "hasAdvanceSerach": true,
                        "idSeparator": ",",
                        "isAutoComplete": 1,
                        "isDetail": 0,
                        "isMultCheckbox": false,
                        "isSingle": true,
                        "linkUrl": "/CRM/data/ViewCustomer.jsp?isrequest=1&CustomerID=",
                        "pageSize": 10,
                        "quickSearchName": "",
                        "title": "客户",
                        "type": "7",
                        "viewAttr": 2
                    },
                    "colSpan": 2,
                    "conditionType": "BROWSER",
                    "domkey": [
                        "crmids"
                    ],
                    "fieldcol": 18,
                    "isQuickSearch": false,
                    "label": "相关客户",
                    "labelcol": 6,
                    "viewAttr": 2
                },
                {
                    "browserConditionParam": {
                        "completeParams": {
                            
                        },
                        "conditionDataParams": {
                            
                        },
                        "dataParams": {
                            
                        },
                        "destDataParams": {
                            
                        },
                        "hasAddBtn": false,
                        "hasAdvanceSerach": true,
                        "idSeparator": ",",
                        "isAutoComplete": 1,
                        "isDetail": 0,
                        "isMultCheckbox": false,
                        "isSingle": true,
                        "linkUrl": "/proj/data/ViewProject.jsp?isrequest=1&ProjID=",
                        "pageSize": 10,
                        "quickSearchName": "",
                        "title": "项目",
                        "type": "8",
                        "viewAttr": 2
                    },
                    "colSpan": 2,
                    "conditionType": "BROWSER",
                    "domkey": [
                        "proids"
                    ],
                    "fieldcol": 18,
                    "isQuickSearch": false,
                    "label": "相关项目",
                    "labelcol": 6,
                    "viewAttr": 2
                }
            ],
            "title": "工作信息"
        }
    ]
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/stores/data.js